<script>
import { apiService } from "@/_services";
import EntriesPagination from "@/components/entries-pagination";
import merge from "lodash/merge";
import isEqual from "lodash/isEqual";

const selectOptions = {
  appsFltr_type: {
    all: "All",
    consumer: "Personal",
    vehicle: "Vehicle",
    realestate: "Real Estate"
  },
  appsFltr_lock: {
    all: "All",
    locked: "Locked",
    unlocked: "Unlocked"
  }
};

const filtersDefault = {
  appsFltr_aMax: "0",
  appsFltr_aMin: "0",
  appsFltr_lock: "all",
  appsFltr_tMax: "0",
  appsFltr_tMin: "0",
  appsFltr_type: "all",
  show: "20",
  paged: 0
};

const initialResult = {
  entries: [],
  entriesCount: 0,
  pages: 0,
  query_vars: {}
};

export default {
  name: "finder",
  components: {
    EntriesPagination
  },
  data() {
    return {
      selectOptions,
      loading: true,
      paged: 0,
      showFilters: false,
      filters: merge({}, filtersDefault, this.$route.query),
      result: initialResult,
      allowFiltersWatch: true
    };
  },
  computed: {
    computedFilters() {
      let filters = merge({}, this.filters, { paged: this.paged });
      if (this.paged < 2) {
        delete filters.paged;
      }
      return filters;
    }
  },
  created() {
    this.get();
  },
  methods: {
    pushQuery() {
      this.$router.push({ query: this.computedFilters });
    },
    get() {
      this.loading = true;
      apiService.finder
        .all({ params: this.computedFilters })
        .then(response => {
          this.result = response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    paginate(page) {
      this.paged = page;
    },
    clickedApplication(post) {
      this.$router.push({
        // path: `/application/${post.ID}/`
        name: "single-application",
        // params: post
        params: {
          id: post.ID,
          data: post
        }
      });
    }
  },
  watch: {
    $route(to) {
      let newQuery = merge({}, filtersDefault, to.query);
      if (!isEqual(this.computedFilters, newQuery)) {
        this.allowFiltersWatch = false;
        this.filters = newQuery;
        this.paged = newQuery.paged || 0;
        setTimeout(
          function() {
            this.allowFiltersWatch = true;
          }.bind(this)
        );
      }
      this.get();
    },
    paged: function() {
      if (!this.allowFiltersWatch) return;
      this.pushQuery();
    },
    filters: {
      handler: function() {
        if (!this.allowFiltersWatch) return;
        if (this.paged == 0) {
          this.pushQuery();
        } else {
          this.paged = 0;
        }
      },
      deep: true
    }
  },
  filters: {
    removeDecimals(value) {
      if (!value) return "";
      return value.split(".")[0];
      // return Math.trunc(value);
    }
  }
};
</script>

<template>
  <div class="view" id="applicationsFinder">
    <div class="view__bar">
      <div class="container">
        <div class="row">
          <div class="rowColumn">
            <h2 class="bar__title">Aplicaciones</h2>
          </div>
          <div class="rowColumn">
            <!-- <button @click="get">Refresh</button> -->
            <!-- <button @click="showFilters = !showFilters">Filters</button> -->
            <a href="" @click.prevent="showFilters = !showFilters">Filters</a>
          </div>
        </div>
      </div>
    </div>

    <form id="applicationsFinder__options" v-show="showFilters">
      <div class="container">
        <div class="filters">
          <div class="filter">
            <h3 class="sbox-title">Loan Type</h3>
            <div class="field">
              <label for="appsFltr_type">Pick one</label>
              <select
                id="appsFltr_type"
                name="appsFltr_type"
                v-model="filters.appsFltr_type"
              >
                <option
                  v-for="(option, key) in selectOptions.appsFltr_type"
                  :value="key"
                  :key="key"
                  >{{ option }}</option
                >
              </select>
            </div>
          </div>
          <div class="filter filter--amount">
            <h3 class="sbox-title">Amount Range</h3>
            <div class="fields">
              <div class="field field--min">
                <label for="appsFltr_aMin">Min</label>
                <input
                  type="number"
                  id="appsFltr_aMin"
                  v-model="filters.appsFltr_aMin"
                  step="1000"
                  min="0"
                  max="1000000000"
                />
              </div>
              <div class="field field--max">
                <label for="appsFltr_aMax">Max</label>
                <input
                  type="number"
                  id="appsFltr_aMax"
                  v-model="filters.appsFltr_aMax"
                  step="1000"
                  min="0"
                  max="1000000000"
                />
              </div>
            </div>
          </div>
          <div class="filter filter--term">
            <h3 class="sbox-title">Term Range</h3>
            <div class="fields">
              <div class="field field--min">
                <label for="appsFltr_tMin">Min</label>
                <input
                  type="number"
                  id="appsFltr_tMin"
                  v-model="filters.appsFltr_tMin"
                  step="1"
                  min="0"
                  max="360"
                />
              </div>
              <div class="field field--max">
                <label for="appsFltr_tMax">Max</label>
                <input
                  type="number"
                  id="appsFltr_tMax"
                  v-model="filters.appsFltr_tMax"
                  step="1"
                  min="0"
                  max="360"
                />
              </div>
            </div>
          </div>
          <div class="filter">
            <h3 class="sbox-title">Lock Status</h3>
            <label for="appsFltr_lock">Pick one</label>
            <select
              id="appsFltr_lock"
              name="appsFltr_lock"
              v-model="filters.appsFltr_lock"
            >
              <option
                v-for="(option, key) in selectOptions.appsFltr_lock"
                :value="key"
                :key="key"
                >{{ option }}</option
              >
            </select>
          </div>
        </div>
      </div>
    </form>

    <sapp-loading v-if="loading" :grow="true" />

    <div
      id="applicationsFinder__feed"
      class="view__content"
      :class="{ loading }"
      v-if="!loading"
    >
      <div class="container">
        <div class="hfeed hfeed-applications">
          <div
            v-for="application in result.entries"
            :key="application.ID"
            :id="'application-' + application.ID"
            class="application sbox-lvl-1"
          >
            <div class="wrapper" @click="clickedApplication(application)">
              <div class="sfield sfield--type">
                <span class="sfield__label">Type</span>
                <span class="sfield__content">
                  <i
                    class="sappfont"
                    :class="'sappfont-loan-' + application.type"
                  ></i>
                  <span class="text">{{ application.type }}</span>
                </span>
              </div>

              <!-- <time class="sfield sfield--date dt-published" :datetime="application.date">
                <span class="sfield__content">{{application.date}}</span>
              </time> -->

              <div class="sfield sfield--amount">
                <span class="sfield__label">Monto</span>
                <span class="sfield__content">{{
                  application.amount | formatMoney | removeDecimals
                }}</span>
              </div>

              <div class="sfield sfield--term">
                <span class="sfield__label">Meses</span>
                <span class="sfield__content">{{ application.term }}</span>
              </div>

              <div class="sfield sfield--lock">
                <span class="sfield__label">Lock Status</span>
                <span class="sfield__content">
                  <template v-if="application.unlocked">
                    <i
                      class="sappfont sappfont-fw sappfont-lock-open has-text-secondary"
                    ></i
                    ><span class="text">Unlocked</span>
                  </template>
                  <template v-else>
                    <i class="sappfont sappfont-fw sappfont-lock-close"></i
                    ><span class="text">Locked</span>
                  </template>
                </span>
              </div>

              <div class="application-options">
                <div class="options-label">
                  <i class="sappfont sappfont-fw sappfont-ellipsis-h-light"></i>
                </div>
                <div class="options-container">
                  <div class="option">Open</div>
                  <div class="option">Hide</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <entries-pagination
          v-if="result.pages > 1"
          :total="result.pages"
          :paged="Number(paged)"
          @paged="paginate($event)"
        ></entries-pagination>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@media only screen {
  #applicationsFinder {
    // padding: 1rem;
    // max-width: 60rem;
    margin: 0 auto;
  }

  .view__content {
    transition: opacity 200ms;
    // padding: 1rem;
  }

  .view__content.loading {
    user-select: none;
    opacity: 0.5;
  }

  #applicationsFinder__options {
    padding: 1rem;
    background-color: #fff;
    input[type="submit"] {
      display: none;
    }
    .filters {
      width: 100%;
    }
    .filter--amount .fields,
    .filter--term .fields {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-column-gap: 1rem;
    }
  }

  .pagination {
    text-align: center;
    margin-top: 1rem;
  }

  .application {
    cursor: pointer;
    margin-bottom: 1px;
    overflow: hidden;
    &:first-child {
      border-bottom-right-radius: 0;
      border-bottom-left-radius: 0;
    }
    &:last-child {
      border-top-right-radius: 0;
      border-top-left-radius: 0;
    }
    &:not(:first-child):not(:last-child) {
      border-radius: 0;
    }
    .wrapper {
      display: grid;
      grid-template-columns:
        4rem 1fr minmax(7rem, 2fr) minmax(5rem, 2fr) 1fr minmax(1rem, 2rem)
        3rem;
      grid-template-areas:
        "type . amount term . lock options"
        "type . amount term . lock options";
      align-items: center;
      min-height: 4rem;
      > * {
        display: inline-block;
      }
      .sfield__label,
      .sfield__content {
        display: block;
      }
      .sfield__label {
        font-size: 0.625rem;
      }
      .sfield--type .sfield__label,
      .sfield--lock .sfield__label {
        display: none;
      }
      .sfield--type {
        grid-area: type;
        text-align: center;
        i {
          font-size: 2rem;
        }
        .text {
          display: none;
        }
      }
      .sfield--date {
        grid-area: date;
        text-align: center;
        font-size: 0.625rem;
      }
      .sfield--amount,
      .sfield--term {
        display: flex;
        flex-direction: column-reverse;
        line-height: 1.2;
      }
      .sfield--amount {
        grid-area: amount;
        text-align: center;
      }
      .sfield--term {
        grid-area: term;
        text-align: center;
      }
      .sfield--amount .sfield__content,
      .sfield--term .sfield__content {
        color: #1d2140;
        font-weight: 700;
        font-size: 0.875rem;
      }
      .sfield--lock {
        grid-area: lock;
        text-align: center;
        .text {
          display: none;
        }
        .sappfont {
          font-size: 1.5rem;
          color: #bbcbdb;
        }
      }
    }
    .application-options {
      grid-area: options;
      text-align: center;
      .options-label {
        font-size: 1.5rem;
        line-height: 1;
        height: 1em;
      }
      .options-container {
        display: none;
      }
    }
  }
}
@media only screen and (max-width: 39.9375em) {
  #applicationsFinder {
    .view__bar {
      border-bottom: 1px solid #dfe6f4;
    }
  }
}
@media only screen and (min-width: 40em) {
  #applicationsFinder {
    #applicationsFinder__options .filters {
      display: grid;
      grid-template-columns: 20% 1fr 1fr 20%;
      grid-column-gap: 1rem;
    }
  }
}
</style>
